import React, { useState,useEffect,useCallback} from "react";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { Container, Grid, Card,CircularProgress, CardMedia, CardContent, Typography, Button, Box, IconButton } from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";
import { Link } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from "react-router-dom";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Banner from '../../../src/assets/GiftAsset/banner.svg';
import Arrow from '../../assets/GiftAsset/arrow.svg';
import ResponsiveNav from "../ptwopproduct/navbar";
import FilterModal from "../ptwopproduct/filter";
import Arrowup from "../../assets/GiftAsset/arrowup.svg"; 
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";



const ProductGrid = () => {
 
  const [favorites, setFavorites] = useState({});
   //eslint-disable-next-line 
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
   //eslint-disable-next-line 
 const [selectedProduct, setSelectedProduct] = useState(null);
  const [openFilter, setOpenFilter] = useState(false);
  // eslint-disable-next-line no-unused-vars
const [products, setProducts] = useState([]);
 // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate();
   const [loading, setLoading] = useState(true); 
   const [pageSize] = useState(9); 
   const [pageNumber, setPageNumber] = useState(1); 
   const [totalPages, setTotalPages] = useState(1);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md')); 
  


  const handleDetails = (product) => {
    if (!product?.productId) {
      console.error("Invalid product selection:", product);
      return;
    }
  
    setSelectedProduct(product); 
    navigate(`/product/details/${product.productId}`);
  };
  
  
  const fetchProducts = useCallback(async () => {
    setLoading(true);
    const token = localStorage.getItem("token");

    if (!token) {
      console.error("Token is missing. Please log in.");
      setLoading(false);
      return;
    }

    const queryParams = new URLSearchParams({
      PageSize: pageSize,
      PageNumber: pageNumber,
    }).toString();

    try {
      const response = await fetch(
        `https://daradservice.azurewebsites.net/api/P2PProducts/get-all-products?${queryParams}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      

      if (result.status && result.data) {
        setProducts(result.data.records || []);
        setTotalPages(result.data.totalPages || 1); 
      } else {
        console.error("Unexpected response format", result);
        setProducts([]);
        setTotalPages(1);
      }
      
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
}, [pageNumber, pageSize]);  

useEffect(() => {
    fetchProducts();
}, [fetchProducts]);  

const nextPage = () => {
    if (pageNumber < totalPages) {
        setPageNumber((prev) => prev + 1);
    }
};

const prevPage = () => {
    if (pageNumber > 1) {
        setPageNumber((prev) => prev - 1);
    }
};

  

  
  

 
  
  
  
  

  

 



    // Handle search input change
    const handleSearchChange = (event) => {
      const query = event.target.value.toLowerCase();
      setSearchTerm(query);
  
      // Filter products by title or description
      const filtered = products.filter(
        (product) =>
          product.title.toLowerCase().includes(query) ||
          product.description.toLowerCase().includes(query)
      );
  
      setFilteredProducts(filtered);
    };
  
    const displayedProducts = searchTerm ? filteredProducts : products;



   
    
   // Filter products
   const toggleFavorite = async (productId) => {
    try {
        const token = localStorage.getItem("token");
        const customerEmail = sessionStorage.getItem("userEmail");

        if (!customerEmail) {
            console.error("No user email found in session storage");
            return;
        }

        
        setFavorites((prevFavorites) => ({
            ...prevFavorites,
            [productId]: !prevFavorites[productId], 
        }));

        const url = `https://daradservice.azurewebsites.net/api/P2PProducts/add-product-to-favorite?productId=${encodeURIComponent(productId)}&customerEmail=${encodeURIComponent(customerEmail)}`;

        const response = await fetch(url, {
            method: "POST",
            headers: {
                Accept: "text/plain",
                Authorization: `Bearer ${token}`,
            },
        });

        const data = await response.text();

        if (!response.ok) {
            console.error("Error:", data);
            // Revert the state if API call fails
            setFavorites((prevFavorites) => ({
                ...prevFavorites,
                [productId]: !prevFavorites[productId], // Revert toggle on failure
            }));
        }
    } catch (error) {
        console.error("Request failed:", error);
        // Revert state in case of error
        setFavorites((prevFavorites) => ({
            ...prevFavorites,
            [productId]: !prevFavorites[productId],
        }));
    }
};




  
  
  
  
  
  
  
  
  
  
  
  
  
  
  //const nonPromotedProducts = filteredProducts.filter(product => product.promotionStatus !== "Active");


  return (
    <Container maxWidth={isDesktop ? "lg" : "sm"} sx={{ py: 4, px: 2 }}
   
  >
  

  <ResponsiveNav
  searchValue={searchTerm}
  onSearchChange={handleSearchChange}
  searchPlaceholder="Search for products by name, category,...."
  breadcrumbItems={[
    { label: 'Home', link: '/' },
    { label: 'P2P MarketPlace', link: '/product/marketplace' }
  ]}
/>
    


         <Box
             sx={{
              borderBottom: "1px solid #ccc",
             mt: isDesktop ? "20px" : "20px",
             pb:"40px"
            }}>  
      <Box
  sx={{
    display: "flex",
    flexDirection: isDesktop ? "row" : "column",
    justifyContent: "space-between",
    alignItems: isDesktop ? "center" : "flex-start",
    textAlign: isDesktop ? "left" : "center",
    gap: isDesktop ? 0 : "16px",
  }}
>
  {/* Heading */}
  <Box sx={{ width: isDesktop ? "auto" : "100%" }}>
    <Typography
      variant="h4"
      fontWeight={700}
      color="#5604F6"
      gutterBottom
      sx={{ fontSize: isDesktop ? "36px" : "28px" }}
    >
      Discover Great Deals
    </Typography>
    <Typography
      variant="h4"
      fontWeight={700}
      color="#5604F6"
      gutterBottom
      sx={{ fontSize: isDesktop ? "36px" : "28px" }}
    >
      From Peers
    </Typography>
  </Box>

  {/* Button */}
  <Link
  to="/product/post_a_product"
  style={{ textDecoration: "none", width: isDesktop ? "auto" : "100%" }}
>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: isDesktop ? "300px" : "100%",
      height: "60px",
      cursor: "pointer",
      border: "2px solid #EEE6FE",
      borderRadius: "9999px",
      padding: "8px",
      color: { xs: "white", md: theme.palette.secondary.main }, 
      backgroundColor: { xs: theme.palette.secondary.main, md: "transparent" }, 
    }}
  >
    <Typography
      variant="h6"
      sx={{
        ...theme.typography.urbanist600,
        fontSize: isDesktop ? "24px" : "20px",
        color: { xs: "white", md: theme.palette.secondary.main }, 
      }}
      component="span"
    >
      Post New Product
    </Typography>
  </Box>
</Link>

</Box>

      <Typography sx={{
                      
                        fontSize: "18px",
                        ...theme.typography.Inter500,
                        mt:"20px"
                      }} >
      Find unbeatable deals from trusted peers. Shop now and save while supporting your community.
      </Typography>
      
      </Box>
      
      {/* Filter Section */}
      <Box display="flex" alignItems="center" justifyContent="space-between" my={3}>
 
      <Box 
      sx={{
        display: "flex",
        alignItems: "center",
        position: "relative",
        "&:hover .post-text": { opacity: 1, transform: "translateX(0)" }
      }}
    >
  
  

</Box>





          {/* Filter Section */}
      <Box display="flex" alignItems="center" justifyContent="space-between" >
      <Button
  startIcon={<TuneIcon sx={{ color: "black" }} />}
  onClick={() => setOpenFilter(true)}  
  sx={{
    color: "black",
    "&:hover": {
      backgroundColor: "transparent",
      border: "1px solid black",
    },
    padding: "8px 16px",
    fontWeight: "bold",
  }}
>
  Filter
</Button>




      </Box>
        
      </Box>

     
     

      {/* Products Grid */}
      
      {loading ? (
  <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
    <CircularProgress />
  </Box>
) : (
  <>
 <Grid container spacing={2}>
 {displayedProducts.length > 0 ? (
  displayedProducts.map((product) => (

            <Grid item xs={12} sm={6} md={4} key={product.id}>
             <Card sx={{ position: "relative", padding: isDesktop ? 3 : 2 }}>
        
        {/* Favorite Icon Button */}
        <IconButton
          onClick={() => toggleFavorite(product.productId)}
          sx={{
            position: "absolute",
            top: isDesktop ? 10 : 5,
            right: isDesktop ? 10 : 5,
            color: "gray",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            borderRadius: "50%",
            zIndex: 2,
          }}
        >
          {favorites[product.productId] ? <FavoriteIcon /> : <FavoriteBorderIcon />}
        </IconButton>

        {/* Product Image with "PROMOTED" Badge */}
        <Box  onClick={() => {
              setSelectedProduct(product);
              handleDetails();
            }}
            sx={{
              cursor: "pointer", position: "relative" }}>
          {product.videoPath?.trim() ? (
            <video
              height="140"
              controls
              src={product.videoPath}
              alt={product.title}
              style={{ width: "100%", cursor: "pointer" }}
              onClick={(e) => e.target.play()}
            />
          ) : (
            <CardMedia
              component="img"
              sx={{
                height: isDesktop ? 200 : 150,
                objectFit: "cover",
              }}
              image={product.imagePath}
              alt={product.title}
            />
          )}

          {product.promotionStatus === "Active" && (
            <Box
              sx={{
                position: "absolute",
                top: "24px",
                backgroundColor: "#F6A704",
                color: "#121212",
                fontWeight: "bold",
                padding: "8px 10px",
                borderRadius: "4px",
                fontSize: "16px",
                ...theme.typography.urbanist600,
              }}
            >
              Promoted
            </Box>
          )}
        </Box>

        <CardContent>
          <Typography 
            variant="h6" 
            sx={{ 
              ...theme.typography.urbanist700, 
              fontSize: isDesktop ? "28px" : "26px" 
            }}
          >
            {product.title}
          </Typography>
          
          <Typography 
            variant="body2" 
            sx={{ ...theme.typography.Inter500, fontSize: "16px" }} 
            color="textSecondary" 
            mb={1}
          >
            {product.description.length > 50 
              ? `${product.description.substring(0, 50)}...` 
              : product.description}
          </Typography>

          <Typography 
            sx={{ 
              ...theme.typography.urbanist800, 
              fontSize: "32px", 
              color: "#F6A704" 
            }}
          >
            ₦{new Intl.NumberFormat('en-NG', { maximumFractionDigits: 0 }).format(product.price)}
          </Typography>

          <Box display="flex" alignItems="center" mt={1}>
            <LocationOnIcon fontSize="small" color="action" />
            <Typography 
              variant="body2" 
              sx={{ 
                ...theme.typography.Inter400, 
                fontSize: "16px" 
              }} 
              color="textSecondary" 
              ml={0.5}
            >
              {product.location}
            </Typography>
          </Box>

          <Button
  fullWidth
  sx={{
    bgcolor: "#5604F6",
    color: "white",
    mt: 2,
    gap: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "9999px",
    fontSize: "16px",
    ...theme.typography.urbanist600,
    padding: "12px 24px",
    textTransform: "none",
    "&:hover": { bgcolor: "#4503D6" },
  }}
  onClick={() => handleDetails(product)} // ← pass product here
>
  View Details
  <img src={Arrow} alt="arrow" />
</Button>

        </CardContent>
      </Card>
            </Grid>
          ))
        ) : (
          <Typography textAlign="center" width="100%" mt={4}>
            {loading ? "Loading..." : "No products available."}
          </Typography>
        )}
      </Grid>

     
    </>
)}



 {/* Pagination Controls */}
 {totalPages > 1 && (
        <Box display="flex" justifyContent="center" alignItems="center" mt={4}>
          <IconButton onClick={prevPage} disabled={pageNumber === 1}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="body1" mx={2}>
            Page {pageNumber} of {totalPages}
          </Typography>
          <IconButton onClick={nextPage} disabled={pageNumber === totalPages}>
            <ArrowForwardIcon />
          </IconButton>
        </Box>
      )}


<Box
  sx={{
    position: "relative",
    width: "100%", 
    margin: isDesktop ? "0" : "0 auto", 
  }}
>
  <Box
    sx={{
      display: "flex",
      flexDirection: { xs: "column", md: "row" },
      alignItems: "center",
      justifyContent: "space-between",
      position: "relative",
      borderRadius: "12px",
      p: isDesktop ? "36px" : "20px",
      mt: isDesktop ? "160px" : "80px",
      background: "linear-gradient(to right, #E7E1D3, #1C1B17)",
      color: "black",
      width: "100%", // Keep width inside the container full
      minHeight: "250px",
      textAlign: isDesktop ? "left" : "center",
    }}
  >
    {/* Left Content - 70% Width */}
    <Box sx={{ flexBasis: isDesktop ? "70%" : "100%", mb: isDesktop ? 0 : "20px" }}>
      <Typography
        sx={{
          ...theme.typography.urbanist700,
          fontSize: isDesktop ? "48px" : "32px",
        }}
      >
        Turn Your Listings <br /> into Bestsellers
      </Typography>
      <Typography
        variant="body1"
        sx={{
          ...theme.typography.Inter400,
          fontSize: isDesktop ? "20px" : "16px",
          mt: "20px",
        }}
        color="textSecondary"
      >
        Promote your products to stay on top and attract more buyers instantly.
      </Typography>

      {/* Promote Product Button */}
      <Button
        variant="contained"
        sx={{
          mt: 2,
          bgcolor: "#5604F6",
          color: "white",
          textTransform: "none",
          borderRadius: "9999px",
          ...theme.typography.urbanist600,
          padding: "10px 24px",
          "&:hover": { bgcolor: "#4503D6" },
          gap: 1,
        }}
      >
        Promote Product
        <img src={Arrowup} alt="No Products" width={10} height={10} />
      </Button>
    </Box>

    {/* Right Section - 30% Width */}
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      {/* Image */}
      <Box
        sx={{
          maxWidth: { xs: "100%", md: "50%" },
          textAlign: "center",
        }}
      >
        <img
          src={Banner}
          alt="Promotion"
          style={{ width: "100%", height: "auto", borderRadius: "8px" }}
        />
      </Box>

      {/* Button */}
      <Button
        variant="contained"
        sx={{
          bgcolor: "white",
          color: "#5604F6",
          textTransform: "none",
          borderRadius: "9999px",
          width: { xs: "auto", md: "300px" },
          height: "50px",
          px: 2,
          py: 1,
          fontSize: { xs: "12px", md: "16px" },
          ...theme.typography.urbanist600,
          "&:hover": { bgcolor: "#f0f0f0" },
        }}
      >
        Boost Now for Just ₦500/Day
      </Button>
    </Box>
  </Box>
</Box>




{openFilter && (
  <FilterModal
    open={openFilter}
    onClose={() => setOpenFilter(false)}
    products={products} 
    setFilteredProducts={setFilteredProducts}
  />
)}




      
{/* Discounted Products Section */}
{/* <Typography variant="h5" fontWeight={600} mt={6} mb={2}>
  Other P2P Products
</Typography> */}

{/* {loading ? ( 
  <Box display="flex" justifyContent="center" alignItems="center" width="100%" height="200px">
    <CircularProgress size={50} color="primary" />
  </Box>
) : ( */}
  {/* <Grid container spacing={2}>
  {loading ? (
    <Typography textAlign="center" width="100%" mt={4}>
      Loading...
    </Typography>
  ) : products.length > 0 ? (
    products
      .filter((product) => product.promotionStatus !== "Active") // Exclude promoted products
      .map((product) => (
        <Grid item xs={12} sm={6} md={4} key={product.id}>
          <Card sx={{ position: "relative", padding: isDesktop ? 3 : 2 }}>
            {/* Favorite Icon Button */}
            {/* <IconButton
              onClick={() => toggleFavorite(product.productId)}
              sx={{
                position: "absolute",
                top: isDesktop ? 10 : 5,
                right: isDesktop ? 10 : 5,
                color: "gray",
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                borderRadius: "50%",
                zIndex: 2,
              }}
            >
              {favorites[product.productId] ? (
                <FavoriteIcon />
              ) : (
                <FavoriteBorderIcon />
              )}
            </IconButton> */}

            {/* Product Image */}
            {/* <Box sx={{ position: "relative" }}>
              {product.videoPath?.trim() ? (
                <video
                  height="140"
                  controls
                  src={product.videoPath}
                  alt={product.title}
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={(e) => e.target.play()}
                />
              ) : (
                <CardMedia
                  component="img"
                  sx={{
                    height: isDesktop ? 200 : 150,
                    objectFit: "cover",
                  }}
                  image={product.imagePath}
                  alt={product.title}
                />
              )}
            </Box> */}

            {/* <CardContent>
              <Typography
                variant="h6"
                sx={{
                  ...theme.typography.urbanist700,
                  fontSize: isDesktop ? "28px" : "26px",
                }}
              >
                {product.title}
              </Typography>

              <Typography
                variant="body2"
                sx={{ ...theme.typography.Inter500, fontSize: "16px" }}
                color="textSecondary"
                mb={1}
              >
                {product.description.length > 50
                  ? `${product.description.substring(0, 50)}...`
                  : product.description}
              </Typography>

              <Typography
                sx={{
                  ...theme.typography.urbanist800,
                  fontSize: "32px",
                  color: "#F6A704",
                }}
              >
                ₦
                {new Intl.NumberFormat("en-NG", {
                  maximumFractionDigits: 0,
                }).format(product.price)}
              </Typography>

              <Box display="flex" alignItems="center" mt={1}>
                <LocationOnIcon fontSize="small" color="action" />
                <Typography
                  variant="body2"
                  sx={{
                    ...theme.typography.Inter400,
                    fontSize: "16px",
                  }}
                  color="textSecondary"
                  ml={0.5}
                >
                  {product.location}
                </Typography>
              </Box>

              <Button
                fullWidth
                sx={{
                  bgcolor: "#5604F6",
                  color: "white",
                  mt: 2,
                  gap: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "9999px",
                  fontSize: "16px",
                  ...theme.typography.urbanist600,
                  padding: "12px 24px",
                  textTransform: "none",
                  "&:hover": { bgcolor: "#4503D6" },
                }}
                onClick={() => {
                  setSelectedProduct(product);
                  handleDetails();
                }}
              >
                View Details
                <img src={Arrow} alt="arrow" />
              </Button>
            </CardContent>
          </Card> */}
        {/* </Grid>
      ))
  // ) : ( */}
  {/* //   <Grid item xs={12}>
  //     <Typography textAlign="center" width="100%" mt={4}>
  //       No products available.
  //     </Typography>
  //   </Grid> */}
  {/* )}
</Grid> */}


{/* )} */} 
{/* */} 


        


    </Container>
  );
};

export default ProductGrid;
